import { api } from './client';

export async function getTodaysChallenges(childId) {
  return api.get(`/challenges/today/${childId}`);
}

export async function revealStretchChallenge(childId) {
  return api.patch(`/challenges/reveal-stretch/${childId}`, {});
}
